<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="57" height="58" viewBox="0 0 57 58" fill="none">
        <g filter="url(#filter0_d_329_3942)">
            <path
                d="M32.7544 40.8031C22.8739 40.8031 14.8637 32.7934 14.8637 22.9124C14.8637 19.2151 15.9857 15.7802 17.9069 12.9287C13.1375 16.1421 10 21.5925 10 27.7761C10 37.6567 18.0102 45.6668 27.8907 45.6668C34.0743 45.6668 39.5247 42.5293 42.7381 37.7598C39.8861 39.6816 36.4513 40.8031 32.7544 40.8031Z"
                fill="white" />
        </g>
        <defs>
            <filter id="filter0_d_329_3942" x="0" y="0.928711" width="56.7383" height="56.7383"
                filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha" />
                <feOffset dx="2" />
                <feGaussianBlur stdDeviation="6" />
                <feComposite in2="hardAlpha" operator="out" />
                <feColorMatrix type="matrix" values="0 0 0 0 0.976471 0 0 0 0 0.760784 0 0 0 0 0.258824 0 0 0 1 0" />
                <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_329_3942" />
                <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_329_3942" result="shape" />
            </filter>
        </defs>
    </svg>
    
</template>